import React from 'react';
import { NoResultsWideCard } from 'apps/sigma2-ui/src/components/NoResultsWideCard';
import { SaveBookmarkIconSvg } from 'apps/sigma2-ui/src/components/svg/SaveBookmarkIcon';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const NoSavedAnalyses = () => {
  const language = useLanguage();

  return (
    <NoResultsWideCard
      icon={<SaveBookmarkIconSvg />}
      leftHandSideContent={
        <>
          <S2Typography
            variant="headline-4-alt"
            translatedContent={language.noSavedAnalysesYet()}
          />
          <S2Typography
            variant="body-6"
            translatedContent={language.youCanSaveAnalyses()}
            textColorVariant="gray-800"
            dangerouslyOverrideClassNameFn={(className) =>
              `${className} tracking-[-0.01em]`
            }
          />
        </>
      }
      rightHandSideContent={
        <>
          <S2Typography
            variant="headline-6-alt"
            translatedContent={language.saveAnalysesForKey()}
            textColorVariant="teal-600"
          />
          <S2Typography
            variant="body-6"
            translatedContent={language.bookmarkAnalysesYouRely()}
            textColorVariant="gray-800"
            dangerouslyOverrideClassNameFn={(className) =>
              `${className} tracking-[-0.01em]`
            }
          />
        </>
      }
    />
  );
};
